<script>
export default {
    name: "ViewSupplier",

    data () {

        return {
            supplier: {},
            active:0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    mounted () {
        this.fetchSupplier();
    },

    methods: {

        fetchSupplier () {
            this.$root.loading = true;
            this.$accountsHttp.get(`SupplierSetup/GetSpecificSupplier?SupplierID=${this.$router.currentRoute.params.supplierID}`)
                .then(response => {
                    this.supplier = response.data.length ? response.data[0] : {};
                    this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        }
    }
}
</script>
<template>
<tail-base-layout>
    <template v-slot:content>
      <tail-card>
            <template v-slot:card-header>
                <h6 class="font-semibold text-sm">Supplier Details</h6>
            </template>
            <template v-slot:card-body>
                <div class="flex flex-wrap">
                    <div class="w-full p-2 rounded-t">
                        <ul class="flex border-b-2">
                          <li class="-mb-px mr-1">
                            <a @click.prevent="active=0" 
                                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                                :class="active == 0 ? activeClass : inActiveClass" href="#">Personal Details</a>
                          </li>
                          <li class="-mb-px mr-1">
                            <a @click.prevent="active=1" 
                                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                                :class="active == 1 ? activeClass : inActiveClass" href="#">Contact Details</a>
                          </li>
                          <li class="-mb-px mr-1">
                            <a @click.prevent="active=2" 
                                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                                :class="active == 2 ? activeClass : inActiveClass" href="#">Items Supplied</a>
                          </li>
                        </ul>
                        <div class="flex flex-wrap w-full" v-if="active==0">
                            <div class="md:w-1/5 sm:w-full p-1 relative">
                              <label class="label-control" for="grid-name">Name:</label>
                              <h5 class="font-bold text-blue-300">{{ supplier.name || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-1">
                                <label class="label-control" for="grid-pin-no">PIN NO:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.piN_No || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-1">
                                <label class="label-control" for="grid-account">
                                    Account:
                                </label>
                                <h5 class="font-bold text-blue-300">{{ supplier.accountNo || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-1">
                                <label class="label-control" for="grid-opening-balance">Opening Bal:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.opening_Bal_ || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-1">
                              <label class="label-control">Current Balance:</label>
                              <h5 class="font-bold text-blue-300">{{ supplier.current_Bal_ || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-1">
                                <label class="label-control" for="grid-credit-limit">Credit Limit:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.creditLimit || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-1">
                                <label class="label-control" for="grid-credit-status">Credit Status:</label>
                                <h5 class="font-bold text-blue-300">-</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-credit-period">Credit Period:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.creditPeriod || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-type">Type:</label>
                                <h5 class="font-bold text-blue-300"></h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-vat-no">VAT NO.:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.vaT_RegNo || '-' }}</h5>
                            </div>
                            <div class="md:w-1/5 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-description">Description:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.description || '-'}}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-active">Active</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.active ? `Yes` : `No` }}</h5>
                            </div>
                        </div>
                        <div class="flex flex-wrap w-full" v-if="active==1">
                            <div class="md:w-1/5 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-contact">Contact:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.contact || '-' }}</h5>
                            </div>
                            <div class="md:w-1/5 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-cell-phone">Cell Phone:</label>
                                <h5 class="font-bold text-blue-400">{{ supplier.cellPhone || '-' }}</h5>
                            </div>
                            <div class="md:w-1/5 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-email">Email:</label>
                                <h5 class="font-bold text-blue-400">{{ supplier.email || '-' }}</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-website">Website:</label>
                                <h5 class="font-bold text-blue-300">{{ supplier.website || '-' }}</h5>
                            </div>
                            <div class="md:w-1/5 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-fax">Fax No.</label>
                                <h5 class="font-bold text-blue-400">{{ supplier.fax || '-' }}</h5>
                            </div>
                            <div class="md:w-1/5 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-location">Location:</label>
                                <h5 class="font-bold text-blue-400">{{ supplier.locatiion || '-' }}</h5>
                            </div>
                            <div class="md:w-1/5 sm:w-full px-3 py-2">
                                <label class="label-control" for="grid-physical-address">Physical Address</label>
                                <h5 class="font-bold text-blue-400">{{ supplier.physicalAddress || '-' }}</h5>
                            </div>
                        </div>
                        <div class="flex flex-wrap w-full" v-if="active==2"></div>
                    </div>
                </div>
            </template>
            <template v-slot:card-footer>
               <div class="w-full text-right">
                 <router-link :to="{ name: `suppliers-dashboard.suppliers.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
               </div>
            </template>
      </tail-card>
    </template>
</tail-base-layout>
</template>
